import clsx from 'clsx'

type ColoredTagProps = {
  label: string
  color?: typeof COLOR_OPTIONS[number]
}

const COLOR_OPTIONS = [
  'blue',
  'green',
  'orange',
  'pink',
  'purple',
  'red',
  'yellow'
] as const

export function ColoredTag (props: ColoredTagProps) {
  const { label, color } = props

  const colorClass = color ? 'tag-' + color : getTagColor(label)

  return (
    <div
      className={clsx(
        'manrope-bold text-md px-2 py-1 rounded-lg',
        colorClass
      )}
    >
      {label}
    </div>
  )
}

const getTagColor = (label: string) => {
  const charCodeSum = label.charCodeAt(0) + label.charCodeAt(label.length - 1)

  return 'tag-' + COLOR_OPTIONS[charCodeSum % COLOR_OPTIONS.length]
}
